export default {
	state: {
		shops: [
			{
				id: '001',
				street: ' 2-я Советская д.74 лит а;б',
				point: 'ЛЕНТА'
			},
			{
				id: '002',
				street: 'Большая Бульварная 15',
				point: 'ЛЕНТА'
			},
			{
				id: '003',
				street: ' Сергея Шило, дом 249-б',
				point: 'МАГНИТ'
			},
			{
				id: '004',
				street: 'Новый 1-й пер, дом 20',
				point: 'МАГНИТ'
			},
			{
				id: '005',
				street: 'пл. Мира, дом 7',
				point: 'МАГНИТ'
			},
			{
				id: '006',
				street: 'Морозова, дом 20',
				point: 'МАГНИТ'
			},
			{
				id: '007',
				street: ' Москатова, дом 31-11',
				point: 'МАГНИТ'
			},
			{
				id: '008',
				street: ' Чучева ул; 32-1; Чучева ул; 38',
				point: 'МАГНИТ'
			},
			{
				id: '009',
				street: 'пер. Гоголевский, д. 2, кор. 2',
				point: 'ПЕРЕКРЕСТОК'
			},
			{
				id: '010',
				street: 'Бакинская, д. 65',
				point: 'ПЕРЕКРЕСТОК'
			}
		]
	},
	mutations: {},
	actions: {},

	getters: {
		getTaganrog (state) {
			return state.shops
		}
	}
}